import AccessToken from "@/helpers/access-token";
import ResumeHash from "@/helpers/resume-hash";

export default {
  isLoggedIn: !!AccessToken.get(),
  isAvailableUncompletedResume: !!ResumeHash.get(),
};
